import { requestData } from "./utils";

export default class SendMessageModule {
  submitMessage(data) {
    return requestData("POST", "/ott/submit-message", data);
  }
  
  submitBroadcast(data) {
    return requestData("POST", "/ott/submit-broadcast", data);
  }

  checkMessageLength(payload) {
    return requestData(
      "POST",
      "/ott/check-message-length",
      payload,
    );
  }

  checkBroadcastLength(payload) {
    return requestData(
      "POST",
      "/ott/check-broadcast-length",
      payload,
    );
  }
}
